import { ethers } from "ethers";
import { Network, Alchemy } from 'alchemy-sdk';

// Optional Config object, but defaults to demo api-key and eth-mainnet.
const settings = {
  apiKey: 'rH_6eF58MmxmyBy3FGdKCTYvUSnBizxH', // Replace with your Alchemy API Key.
  network: Network.MATIC_MUMBAI, // Replace with your network.
};

const alchemy = new Alchemy(settings);

// moralis node https://site1.moralis-nodes.com/bsc-testnet/be348eecea6643b8a11d9df4d1e939a2

// BSC TESTNET
export const luckBlocksAddress = "0xBFeC98Cde983769a5f66e41C190944450FB73936"; // "0xBFeC98Cde983769a5f66e41C190944450FB73936";
export const luckBlocksWAddress = "0xa6EBa8a7D06091120F8B6eEe6012031Fd41F64B0";
export const ethLuckBlocksAddress = "0x1aC35135Dd761bEA734aE3c25C14556D2237dF47";
export const ethluckBlocksWAddress = "0x9d5a347E6b9C60CC3882f0792cAC8797b354a270";
export const maticLuckBlocksAddress = "0x8Ad9A4F67De0e2d20eAF3DC6310E090Ce7Be0d0C";
export const maticLuckBlocksWAddress = "0xaa5A3A712C33C57FcAf97423cB1FC45358AB28b7";
export const CRANNILuckBlocksAddress = "0x91CfA49E2677ed5C0175AA2FA41D011ae2c417Ac";
export const CRANNILuckBlocksWAddress = "0x84623C56E7E2b33e3321aC4ACd17e4Cc537f4111";
export const cynthsAddress = "0x203AfA9D0aE657939a31110dd9b22e3fBB1017A3";
export const MultiCall = "0xD855c21e038Fe5f6146f480aDeEdD0d96d2212C3";
export const erc20Address = "0x2a3E6a9824c1f59AEFDe1f5eC4F2b4c3460C6992"; // USDT address 0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174
export const cranniAddress = "0x8C426Bc4506b4f7BfB21cF67A342e0E7EBe0980f"; // mainnet address : 0x671078C0496Fa135a8c45fC7c9FA7B1501fD5146
export const stakingContract = "0xCC205BB6B3942348f31Fd0385e2f0f7C11F2d33c";
export const lpToken = "0x68c000A1E9F1DcE62358019716B5300937d2b659";
export const nftNodes = "0x49c3844b00AA8268E41959c18D84d56F8De5F9dc";
export const nftNodesCFG = "0x17Fc1Fe5bCD865d88a03A7031C18cCaFE8fBA427";
export const bullvsbear = "0x309cB3b43C0B8Ec64776e4DDf4aa71B971d383bf";
export const lbreferral = "0x12C5466642CFbE5A50151C834b16Ad4A5C8e9181";

export const wsprovider = new ethers.providers.WebSocketProvider(
	`wss://bsc-testnet.drpc.org`
);

export const alchemyBase = alchemy;

export const provider = new ethers.providers.JsonRpcProvider(
	`https://bsc-testnet.bnbchain.org`
);
export const bckpProvider = new ethers.providers.WebSocketProvider(
	`wss://bsc-testnet.drpc.org`
)